import Head from "next/head";

export default function OgUrl({ url } : { url: string }) {
  return (
    <Head>
      <meta property="og:url" content={url} />
    </Head>
  )
}